import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { SPDateTimeField } from '../components/Table/fields/SPDateTimeField';

export const guideHaveTimeStaff: SchemaWithClient<any> = {
  name: 'Guide Have Time',
  pluralName: 'Guide Have Time',
  description: 'Please provide the time intervals when you are not available.',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      required: false,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      hide: true,
    },
    from: {
      name: 'From',
      fieldRenderer: SPDateField,
      slidePaneFieldRenderer: SPDateTimeField,
      fieldType: 'date',
    },
    to: {
      name: 'To',
      fieldRenderer: SPDateField,
      slidePaneFieldRenderer: SPDateTimeField,
      fieldType: 'date',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/staff/guide-have-times'),
};
